<template>
  <div>
    <b-dropdown 
      v-b-tooltip.hover 
      :variant="inspectie.isBevroren ? 'warning' : 'success'" 
      :title="isLoadingPrognose ? 'Prognose wordt nog geladen...' : (inspectie.isBevroren ? 'Deze prognose kan alleen bewerkt worden door de beheerder' : '')" 
      :disabled="isLoadingPrognose"
      split
      @click="onUpdate"
    >
      <template #button-content>
        <i class="fa fa-file" /> Opslaan
      </template>
      <b-dropdown-item 
        :disabled="isLoadingPrognose"
        @click="showModal = true"
      >
        <i class="fa fa-save" /> Opslaan...
      </b-dropdown-item>
    </b-dropdown>

    <slot />

    <b-modal 
      v-model="showModal" 
      title="Prognose opslaan" 
      ok-title="Opslaan" 
      ok-variant="success" 
      :ok-disabled="isLoadingPrognose"
      cancel-title="Annuleren" 
      @ok="onOk"
    >
      <b-form-group 
        label="Omschrijving" 
        description="Hier kan een afwijkende omschrijving worden opgegeven. "
      >
        <b-input
          v-model="inspectie.omschrijving"
          :placeholder="unit.UnitKenmerk"
          maxlength="100"
        />
      </b-form-group>
      <b-form-group label="Inspecteur ">
        <inspecteur-select v-model="inspectie.inspecteur" />
      </b-form-group>
      <b-form-group label="Datum inspectie">
        <DateInputField v-model="inspectie.datum" />
      </b-form-group>

      <b-form-group label="Voortgang inspectie">
        <b-input-group>
          <b-input-group-prepend is-text>
            <b-checkbox 
              v-model="inspectie.gereed" 
            >
              Inspectie voltooid
            </b-checkbox>
          </b-input-group-prepend>
          <b-input-group-prepend is-text>
            Aantal uren
          </b-input-group-prepend>
          <b-input 
            v-model.number="inspectie.uren" 
            type="number"
          />
        </b-input-group>
      </b-form-group>

      <b-form-group>
        <b-card-title>Taken van de checklist</b-card-title>
        <b-tabs
          v-model="checklistTab" 
          justified
          @change="() => checkTodo(selectedType)"
        >
          <b-tab 
            v-for="tab in types"
            :key="tab" 
            :title="tab" 
            no-body
          >
            <b-list-group>
              <b-radio-group>
                <b-list-group-item 
                  v-for="t in todosFiltered" 
                  :key="t.data.id" 
                  :variant="t.data.id == selectedTodo ? 'secondary' : 'default'"
                >
                  <b-radio 
                    v-model="selectedTodo" 
                    :value="t.data.id"
                  >
                    {{ t.titel }}
                    <b-form-checkbox
                      v-if="selectedTodo == t.data.id" 
                      :key="t.data.id" 
                      v-model="isTodoCompleted"
                      size="lg"
                    >
                      Voltooid
                    </b-form-checkbox>
                  </b-radio>
                </b-list-group-item>
                <b-alert 
                  v-if="todosFiltered.length == 0 && todos.length > 0" 
                  show 
                  variant="warning"
                >
                  Geen {{ selectedType.toLowerCase() }} die in aanmerking komen
                </b-alert>
                <b-list-group-item v-if="inspectie.gereed">
                  <b-checkbox 
                    v-model="createTodo"
                  >
                    <b>Nieuwe taak</b> {{ unit.UnitKenmerk }} {{ unit.Adres }} 
                    <span v-if="createTodo">
                      Accordering door <inspecteur-select
                        :value="todoAuditor"
                        :allow-beheerders="true"
                        :eigen-groep-alleen="true"
                        @input="todoAuditor = $event ? { Id: $event.id, Naam: $event.naam } : null"
                      />
                      <b-form-checkbox
                        key="Nieuwe-taak"
                        v-model="isTodoCompleted" 
                        size="lg"
                      > Voltooid </b-form-checkbox>
                      <b-textarea 
                        v-model="todoAuditorNote" 
                        placeholder="Extra notitie"
                      />
                    </span>
                  </b-checkbox>
                </b-list-group-item>
              </b-radio-group>
            </b-list-group>
          </b-tab>
        </b-tabs>
      </b-form-group>

      <b-form-group label="Overig">
        <b-check v-model="inspectie.isTemplate">
          Deze prognose kan gebruikt worden als template
        </b-check>
        <b-check v-model="inspectie.isBevroren">
          Deze inspectie is bevroren
        </b-check>
      </b-form-group>

      <b-alert 
        :show="inspectie.isBevroren" 
        variant="warning"
      >
        Wanneer deze prognose al op slot staat kan deze alleen door de beheerder worden aangepast.
      </b-alert>
    </b-modal>
  </div>
</template>

<script>
  import { setupCalendar } from "v-calendar";
  import { serviceMixin } from "@/mixins/serviceMixin";
  import InspecteurSelect from '@/components/InspecteurSelect.vue';
  import DateInputField from '../../components/DateInputField.vue';
  setupCalendar({
    firstDayOfWeek: 2, // Monday
  });
  export default {
    components: {
        InspecteurSelect,
        DateInputField
    },
    mixins: [ serviceMixin ],
    props: {
      inspectie: {
        type: Object,
        default: null,
      },
      unit: {
        type: Object,
        default: null
      },
      onUpdate: {
        type: Function,
        default: null
      },
      onDelete: {
        type: Function,
        default: null
      },
    },
    data() {
      return {
        checklistTab: null,
        createTodo: false,
        showModal: false,
        todos: [],
        selectedTodo: null,
        todoAuditor: null,
        todoAuditorNote: null,
        isTodoCompleted: this.inspectie.gereed,
        types: ['NulInspecties','Herinspecties']
      };
    },
    computed: {
      isLoadingPrognose: function() {
        return this.inspectie.omschrijving === 'Ophalen...';
      },
      selectedType: function() {
        return this.types[this.checklistTab].toLowerCase()
      },
      todosFiltered: function() {
        // this.unit.Complex.Relatie.Id
        return this.todos.filter(t => (t.data.unit == null || this.unit.Id == t.data.unit.id))
      },
      checklistAction: function() {
        if (this.selectedTodo == null) {
          if (this.createTodo) {
            return {
              action: 'createTaak',
              data: {
                auditor: this.todoAuditor,
                completed: this.isTodoCompleted,
                omschrijving: this.todoAuditorNote,
                type: this.selectedType.substring(0, this.selectedType.length - 1).toLowerCase()
              }
            }
          } else {
            return {
              action: 'none',
              data: null
            };
          }
        } else {
          return {
            action: 'updateTaak',
            data: {
              todo: this.selectedTodo,
              completed: this.isTodoCompleted
          }
          }
        }
      },
      todoPath: function() {
        return `/unit/${this.unit.Id}/taken/${this.selectedType}`
      },
    },
    watch: {
      'inspectie.gereed': function(newVal) {
        this.isTodoCompleted = newVal
      },
      'checklistTab': function() {
        this.checkTodo();
      }
    },
    methods: {
      onOk() {
        // Prevent saving if prognose is still loading
        if (this.isLoadingPrognose) {
          this.$bvToast.toast('Kan niet opslaan terwijl de prognose nog wordt geladen.', {
            title: 'Prognose wordt geladen',
            variant: 'warning',
            solid: true
          });
          return;
        }
        this.showModal = false;
        this.onUpdate(this.checklistAction);
      },
      checkTodo() {
        this.todos=[]
        var vm = this
        console.log(this.todoPath)
        this.get(this.todoPath).then((response) => {
          console.log(response);
          vm.todos = response.data.events;
        })
      }
    },
  };

</script>